/*
 * @fileOverView Tasks component definition
 */

import Vue from 'vue';

/**
 * Tasks Vue
 * @type {class}
 */
Vue.component('tasks-vue', {
  data: function() {
    return {
      isCollapsed: false
    }
  },

  watch: {
    isCollapsed: function (val) {
      localStorage.tasksCollapsed = val;
    }
  },

  mounted() {
    // Respects the collapsed state through page loads.
    if (localStorage.tasksCollapsed !== null) {
      this.isCollapsed = localStorage.tasksCollapsed === 'true';
    }
  }
});
